define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"Apparel/MaterialRefMixin"
], function(declare,Ref,MaterialRefMixin) {

	return declare([Ref, MaterialRefMixin], {
		_bForStyleBOM: true
	});
});